/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
import styled from 'styled-components';

type EnrollSelectionCardProps = {
  disable: boolean;
  selected: boolean;
};

export const EnrollSelectionCardContainer = styled.div<EnrollSelectionCardProps>`
  display: inline-block;
  cursor: pointer;
  margin: 0px 10px 0px 10px;

  border-radius: 4px;
  box-shadow: 0px 5px 20px #00000029;
  background: ${props => (props.disable ? '#DADADD' : '#fff')};
  opacity: ${props => (props.disable ? '0.5' : '1')};
  outline: ${props => (props.selected ? '3px solid #2DCAFC' : '')};
`;

export const CardImgContainer = styled.div`
  display: flex;
  flex-grow: 2;
  height: 100px;
  border-radius: 4px 4px 0 0;
  justify-content: flex-end;
`;

export const FallbackImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px 4px 0 0;
`;

export const ImgBox = styled.div`
  /* now a container for the image */
  width: 100%;
  height: 100%;
  display: inline-block; /* shrink wrap to image */
  overflow: hidden; /* hide the excess */
`;

export const CardContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 80px;
  flex-grow: 1;
  background: transparent linear-gradient(180deg, #ffffff 0%, #ffffff 100%) 0% 0% no-repeat padding-box;
  border-radius: 0px 0px 4px 4px;
  box-shadow: 0px 5px 5px #00000029;
`;

export const CardContentTitle = styled.div`
  display: flex;
  width: 100%;
  height: 39px;
  font-size: 16px;
  font-weight: 600;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const ContentTitle = styled.span`
  font-size: 16px;
  padding: 10px 20px;
`;

export const ContentText = styled.span`
  font-size: 16px;
  padding: 10px 20px 35px;
`;

export const ContentLink = styled.span`
  font-size: 16px;
  padding: 0px 20px;
  text-decoration: underline;
  color: #2dcafc;
  margin-bottom: 10px;
`;
